import ReactModal from "react-modal";
import { useSelector } from "react-redux";

import AuthGate from "shared/components/AuthGate";
import AuthUserGate from "shared/components/AuthUserGate";
import { GateProps } from "shared/components/GateProps";
import StainGate from "shared/components/StainGate";
import useInteractionListener from "shared/hooks/useInteractionListener";
import {
  selectMfaSetupRequired,
  selectIsAccessTokenExpired,
  selectIsRefreshTokenExpired,
} from "shared/reducers/authReducer";

import AppRoutes from "AppRoutes";
import FrontLoadGate from "gates/FrontLoadGate";
import LabFrontLoadGate from "gates/LabFrontLoadGate";
import StationSelectionGate from "gates/StationSelectionGate";
import LoginRoutes from "LoginRoutes";
import MfaMethodSelectionPage from "pages/MfaMethodSelectionPage";
import AppError from "ui/components/AppError";
import AppSpinner from "ui/components/AppSpinner";

ReactModal.setAppElement("#root");

function App() {
  const isAccessTokenExpired = useSelector(selectIsAccessTokenExpired);
  const isRefreshTokenExpired = useSelector(selectIsRefreshTokenExpired);
  const mfaSetupRequired = useSelector(selectMfaSetupRequired);

  useInteractionListener();

  if (isAccessTokenExpired && isRefreshTokenExpired) return <LoginRoutes />;

  if (mfaSetupRequired) return <MfaMethodSelectionPage />;

  const gateProps: Omit<GateProps, "children"> = {
    LoadingEl: AppSpinner,
    ErrorEl: AppError,
  };

  return (
    <AuthGate {...gateProps}>
      <AuthUserGate {...gateProps}>
        <FrontLoadGate {...gateProps}>
          <StainGate {...gateProps}>
            <StationSelectionGate>
              <LabFrontLoadGate {...gateProps}>
                <AppRoutes />
              </LabFrontLoadGate>
            </StationSelectionGate>
          </StainGate>
        </FrontLoadGate>
      </AuthUserGate>
    </AuthGate>
  );
}

export default App;
